// @generated by protobuf-ts 2.9.1 with parameter generate_dependencies
// @generated from protobuf file "rogue.proto" (package "proto", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { UnitReference } from "./common";
/**
 * @generated from protobuf message proto.RogueTalents
 */
export interface RogueTalents {
    /**
     * Assassination
     *
     * @generated from protobuf field: int32 improved_eviscerate = 1;
     */
    improvedEviscerate: number;
    /**
     * @generated from protobuf field: int32 remorseless_attacks = 2;
     */
    remorselessAttacks: number;
    /**
     * @generated from protobuf field: int32 malice = 3;
     */
    malice: number;
    /**
     * @generated from protobuf field: int32 ruthlessness = 4;
     */
    ruthlessness: number;
    /**
     * @generated from protobuf field: int32 blood_spatter = 5;
     */
    bloodSpatter: number;
    /**
     * @generated from protobuf field: int32 puncturing_wounds = 6;
     */
    puncturingWounds: number;
    /**
     * @generated from protobuf field: bool vigor = 7;
     */
    vigor: boolean;
    /**
     * @generated from protobuf field: int32 improved_expose_armor = 8;
     */
    improvedExposeArmor: number;
    /**
     * @generated from protobuf field: int32 lethality = 9;
     */
    lethality: number;
    /**
     * @generated from protobuf field: int32 vile_poisons = 10;
     */
    vilePoisons: number;
    /**
     * @generated from protobuf field: int32 improved_poisons = 11;
     */
    improvedPoisons: number;
    /**
     * @generated from protobuf field: int32 fleet_footed = 12;
     */
    fleetFooted: number;
    /**
     * @generated from protobuf field: bool cold_blood = 13;
     */
    coldBlood: boolean;
    /**
     * @generated from protobuf field: int32 improved_kidney_shot = 14;
     */
    improvedKidneyShot: number;
    /**
     * @generated from protobuf field: int32 quick_recovery = 15;
     */
    quickRecovery: number;
    /**
     * @generated from protobuf field: int32 seal_fate = 16;
     */
    sealFate: number;
    /**
     * @generated from protobuf field: int32 murder = 17;
     */
    murder: number;
    /**
     * @generated from protobuf field: int32 deadly_brew = 18;
     */
    deadlyBrew: number;
    /**
     * @generated from protobuf field: bool overkill = 19;
     */
    overkill: boolean;
    /**
     * @generated from protobuf field: int32 deadened_nerves = 20;
     */
    deadenedNerves: number;
    /**
     * @generated from protobuf field: int32 focused_attacks = 21;
     */
    focusedAttacks: number;
    /**
     * @generated from protobuf field: int32 find_weakness = 22;
     */
    findWeakness: number;
    /**
     * @generated from protobuf field: int32 master_poisoner = 23;
     */
    masterPoisoner: number;
    /**
     * @generated from protobuf field: bool mutilate = 24;
     */
    mutilate: boolean;
    /**
     * @generated from protobuf field: int32 turn_the_tables = 25;
     */
    turnTheTables: number;
    /**
     * @generated from protobuf field: int32 cut_to_the_chase = 26;
     */
    cutToTheChase: number;
    /**
     * @generated from protobuf field: bool hunger_for_blood = 27;
     */
    hungerForBlood: boolean;
    /**
     * Combat
     *
     * @generated from protobuf field: int32 improved_gouge = 28;
     */
    improvedGouge: number;
    /**
     * @generated from protobuf field: int32 improved_sinister_strike = 29;
     */
    improvedSinisterStrike: number;
    /**
     * @generated from protobuf field: int32 dual_wield_specialization = 30;
     */
    dualWieldSpecialization: number;
    /**
     * @generated from protobuf field: int32 improved_slice_and_dice = 31;
     */
    improvedSliceAndDice: number;
    /**
     * @generated from protobuf field: int32 deflection = 32;
     */
    deflection: number;
    /**
     * @generated from protobuf field: int32 precision = 33;
     */
    precision: number;
    /**
     * @generated from protobuf field: int32 endurance = 34;
     */
    endurance: number;
    /**
     * @generated from protobuf field: bool riposte = 35;
     */
    riposte: boolean;
    /**
     * @generated from protobuf field: int32 close_quarters_combat = 36;
     */
    closeQuartersCombat: number;
    /**
     * @generated from protobuf field: int32 improved_kick = 37;
     */
    improvedKick: number;
    /**
     * @generated from protobuf field: int32 improved_sprint = 38;
     */
    improvedSprint: number;
    /**
     * @generated from protobuf field: int32 lightning_reflexes = 39;
     */
    lightningReflexes: number;
    /**
     * @generated from protobuf field: int32 aggression = 40;
     */
    aggression: number;
    /**
     * @generated from protobuf field: int32 mace_specialization = 41;
     */
    maceSpecialization: number;
    /**
     * @generated from protobuf field: bool blade_flurry = 42;
     */
    bladeFlurry: boolean;
    /**
     * @generated from protobuf field: int32 hack_and_slash = 43;
     */
    hackAndSlash: number;
    /**
     * @generated from protobuf field: int32 weapon_expertise = 44;
     */
    weaponExpertise: number;
    /**
     * @generated from protobuf field: int32 blade_twisting = 45;
     */
    bladeTwisting: number;
    /**
     * @generated from protobuf field: int32 vitality = 46;
     */
    vitality: number;
    /**
     * @generated from protobuf field: bool adrenaline_rush = 47;
     */
    adrenalineRush: boolean;
    /**
     * @generated from protobuf field: int32 nerves_of_steel = 48;
     */
    nervesOfSteel: number;
    /**
     * @generated from protobuf field: int32 throwing_specialization = 49;
     */
    throwingSpecialization: number;
    /**
     * @generated from protobuf field: int32 combat_potency = 50;
     */
    combatPotency: number;
    /**
     * @generated from protobuf field: int32 unfair_advantage = 51;
     */
    unfairAdvantage: number;
    /**
     * @generated from protobuf field: bool surprise_attacks = 52;
     */
    surpriseAttacks: boolean;
    /**
     * @generated from protobuf field: int32 savage_combat = 53;
     */
    savageCombat: number;
    /**
     * @generated from protobuf field: int32 prey_on_the_weak = 54;
     */
    preyOnTheWeak: number;
    /**
     * @generated from protobuf field: bool killing_spree = 55;
     */
    killingSpree: boolean;
    /**
     * Subtlety
     *
     * @generated from protobuf field: int32 relentless_strikes = 56;
     */
    relentlessStrikes: number;
    /**
     * @generated from protobuf field: int32 master_of_deception = 57;
     */
    masterOfDeception: number;
    /**
     * @generated from protobuf field: int32 opportunity = 58;
     */
    opportunity: number;
    /**
     * @generated from protobuf field: int32 sleight_of_hand = 59;
     */
    sleightOfHand: number;
    /**
     * @generated from protobuf field: int32 dirty_tricks = 60;
     */
    dirtyTricks: number;
    /**
     * @generated from protobuf field: int32 camouflage = 61;
     */
    camouflage: number;
    /**
     * @generated from protobuf field: int32 elusiveness = 62;
     */
    elusiveness: number;
    /**
     * @generated from protobuf field: bool ghostly_strike = 63;
     */
    ghostlyStrike: boolean;
    /**
     * @generated from protobuf field: int32 serrated_blades = 64;
     */
    serratedBlades: number;
    /**
     * @generated from protobuf field: int32 setup = 65;
     */
    setup: number;
    /**
     * @generated from protobuf field: int32 initiative = 66;
     */
    initiative: number;
    /**
     * @generated from protobuf field: int32 improved_ambush = 67;
     */
    improvedAmbush: number;
    /**
     * @generated from protobuf field: int32 heightened_senses = 68;
     */
    heightenedSenses: number;
    /**
     * @generated from protobuf field: bool preparation = 69;
     */
    preparation: boolean;
    /**
     * @generated from protobuf field: int32 dirty_deeds = 70;
     */
    dirtyDeeds: number;
    /**
     * @generated from protobuf field: bool hemorrhage = 71;
     */
    hemorrhage: boolean;
    /**
     * @generated from protobuf field: int32 master_of_subtlety = 72;
     */
    masterOfSubtlety: number;
    /**
     * @generated from protobuf field: int32 deadliness = 73;
     */
    deadliness: number;
    /**
     * @generated from protobuf field: int32 enveloping_shadows = 74;
     */
    envelopingShadows: number;
    /**
     * @generated from protobuf field: bool premeditation = 75;
     */
    premeditation: boolean;
    /**
     * @generated from protobuf field: int32 cheat_death = 76;
     */
    cheatDeath: number;
    /**
     * @generated from protobuf field: int32 sinister_calling = 77;
     */
    sinisterCalling: number;
    /**
     * @generated from protobuf field: int32 waylay = 78;
     */
    waylay: number;
    /**
     * @generated from protobuf field: int32 honor_among_thieves = 79;
     */
    honorAmongThieves: number;
    /**
     * @generated from protobuf field: bool shadowstep = 80;
     */
    shadowstep: boolean;
    /**
     * @generated from protobuf field: int32 filthy_tricks = 81;
     */
    filthyTricks: number;
    /**
     * @generated from protobuf field: int32 slaughter_from_the_shadows = 82;
     */
    slaughterFromTheShadows: number;
    /**
     * @generated from protobuf field: bool shadow_dance = 83;
     */
    shadowDance: boolean;
}
/**
 * @generated from protobuf message proto.Rogue
 */
export interface Rogue {
    /**
     * @generated from protobuf field: proto.Rogue.Rotation rotation = 1;
     */
    rotation?: Rogue_Rotation;
    /**
     * @generated from protobuf field: proto.Rogue.Options options = 3;
     */
    options?: Rogue_Options;
}
/**
 * @generated from protobuf message proto.Rogue.Rotation
 */
export interface Rogue_Rotation {
    /**
     * @generated from protobuf field: proto.Rogue.Rotation.Frequency expose_armor_frequency = 1;
     */
    exposeArmorFrequency: Rogue_Rotation_Frequency;
    /**
     * @generated from protobuf field: int32 minimum_combo_points_expose_armor = 2;
     */
    minimumComboPointsExposeArmor: number;
    /**
     * @generated from protobuf field: proto.Rogue.Rotation.Frequency tricks_of_the_trade_frequency = 3;
     */
    tricksOfTheTradeFrequency: Rogue_Rotation_Frequency;
    /**
     * @generated from protobuf field: proto.Rogue.Rotation.CombatPriority combat_finisher_priority = 4;
     */
    combatFinisherPriority: Rogue_Rotation_CombatPriority;
    /**
     * @generated from protobuf field: proto.Rogue.Rotation.CombatBuilder combat_builder = 25;
     */
    combatBuilder: Rogue_Rotation_CombatBuilder;
    /**
     * @generated from protobuf field: proto.Rogue.Rotation.AssassinationPriority assassination_finisher_priority = 5;
     */
    assassinationFinisherPriority: Rogue_Rotation_AssassinationPriority;
    /**
     * @generated from protobuf field: proto.Rogue.Rotation.SubtletyBuilder subtlety_builder = 26;
     */
    subtletyBuilder: Rogue_Rotation_SubtletyBuilder;
    /**
     * @generated from protobuf field: proto.Rogue.Rotation.SubtletyPriority subtlety_finisher_priority = 6;
     */
    subtletyFinisherPriority: Rogue_Rotation_SubtletyPriority;
    /**
     * @generated from protobuf field: int32 minimum_combo_points_primary_finisher = 7;
     */
    minimumComboPointsPrimaryFinisher: number;
    /**
     * @generated from protobuf field: int32 minimum_combo_points_secondary_finisher = 8;
     */
    minimumComboPointsSecondaryFinisher: number;
    /**
     * @generated from protobuf field: proto.Rogue.Rotation.Frequency MultiTargetSliceFrequency = 9 [json_name = "MultiTargetSliceFrequency"];
     */
    multiTargetSliceFrequency: Rogue_Rotation_Frequency;
    /**
     * @generated from protobuf field: int32 minimum_combo_points_multi_target_slice = 10;
     */
    minimumComboPointsMultiTargetSlice: number;
    /**
     * @generated from protobuf field: bool use_feint = 12;
     */
    useFeint: boolean;
    /**
     * @generated from protobuf field: bool open_with_garrote = 15;
     */
    openWithGarrote: boolean;
    /**
     * @generated from protobuf field: bool open_with_premeditation = 16;
     */
    openWithPremeditation: boolean;
    /**
     * @generated from protobuf field: bool open_with_shadowstep = 17;
     */
    openWithShadowstep: boolean;
    /**
     * @generated from protobuf field: bool rupture_for_bleed = 18;
     */
    ruptureForBleed: boolean;
    /**
     * @generated from protobuf field: bool hemo_with_dagger = 20;
     */
    hemoWithDagger: boolean;
    /**
     * @generated from protobuf field: bool use_ghostly_strike = 24;
     */
    useGhostlyStrike: boolean;
}
/**
 * @generated from protobuf enum proto.Rogue.Rotation.Frequency
 */
export enum Rogue_Rotation_Frequency {
    /**
     * @generated from protobuf enum value: Never = 0;
     */
    Never = 0,
    /**
     * @generated from protobuf enum value: Once = 1;
     */
    Once = 1,
    /**
     * @generated from protobuf enum value: Maintain = 2;
     */
    Maintain = 2,
    /**
     * @generated from protobuf enum value: FrequencyUnknown = 5;
     */
    FrequencyUnknown = 5
}
/**
 * @generated from protobuf enum proto.Rogue.Rotation.CombatPriority
 */
export enum Rogue_Rotation_CombatPriority {
    /**
     * @generated from protobuf enum value: RuptureEviscerate = 0;
     */
    RuptureEviscerate = 0,
    /**
     * @generated from protobuf enum value: EviscerateRupture = 1;
     */
    EviscerateRupture = 1,
    /**
     * @generated from protobuf enum value: CombatPriorityUnknown = 2;
     */
    CombatPriorityUnknown = 2
}
/**
 * @generated from protobuf enum proto.Rogue.Rotation.CombatBuilder
 */
export enum Rogue_Rotation_CombatBuilder {
    /**
     * @generated from protobuf enum value: SinisterStrike = 0;
     */
    SinisterStrike = 0,
    /**
     * @generated from protobuf enum value: Backstab = 1;
     */
    Backstab = 1,
    /**
     * @generated from protobuf enum value: HemorrhageCombat = 2;
     */
    HemorrhageCombat = 2
}
/**
 * @generated from protobuf enum proto.Rogue.Rotation.AssassinationPriority
 */
export enum Rogue_Rotation_AssassinationPriority {
    /**
     * @generated from protobuf enum value: EnvenomRupture = 0;
     */
    EnvenomRupture = 0,
    /**
     * @generated from protobuf enum value: RuptureEnvenom = 1;
     */
    RuptureEnvenom = 1,
    /**
     * @generated from protobuf enum value: AssassinationPriorityUnknown = 2;
     */
    AssassinationPriorityUnknown = 2
}
/**
 * @generated from protobuf enum proto.Rogue.Rotation.SubtletyBuilder
 */
export enum Rogue_Rotation_SubtletyBuilder {
    /**
     * @generated from protobuf enum value: Hemorrhage = 0;
     */
    Hemorrhage = 0,
    /**
     * @generated from protobuf enum value: BackstabSub = 1;
     */
    BackstabSub = 1
}
/**
 * @generated from protobuf enum proto.Rogue.Rotation.SubtletyPriority
 */
export enum Rogue_Rotation_SubtletyPriority {
    /**
     * @generated from protobuf enum value: SubtletyEviscerate = 0;
     */
    SubtletyEviscerate = 0,
    /**
     * @generated from protobuf enum value: SubtletyEnvenom = 1;
     */
    SubtletyEnvenom = 1,
    /**
     * @generated from protobuf enum value: SubtletyPriorityUnknown = 2;
     */
    SubtletyPriorityUnknown = 2
}
/**
 * @generated from protobuf message proto.Rogue.Options
 */
export interface Rogue_Options {
    /**
     * @generated from protobuf field: proto.UnitReference tricks_of_the_trade_target = 1;
     */
    tricksOfTheTradeTarget?: UnitReference;
    /**
     * @generated from protobuf field: proto.Rogue.Options.PoisonImbue mh_imbue = 2;
     */
    mhImbue: Rogue_Options_PoisonImbue;
    /**
     * @generated from protobuf field: proto.Rogue.Options.PoisonImbue oh_imbue = 3;
     */
    ohImbue: Rogue_Options_PoisonImbue;
    /**
     * @generated from protobuf field: int32 starting_overkill_duration = 4;
     */
    startingOverkillDuration: number;
    /**
     * @generated from protobuf field: bool apply_poisons_manually = 5;
     */
    applyPoisonsManually: boolean;
    /**
     * @generated from protobuf field: int32 honor_of_thieves_crit_rate = 6;
     */
    honorOfThievesCritRate: number;
    /**
     * @generated from protobuf field: bool assume_bleed_active = 7;
     */
    assumeBleedActive: boolean;
    /**
     * @generated from protobuf field: float vanish_break_time = 8;
     */
    vanishBreakTime: number;
}
/**
 * @generated from protobuf enum proto.Rogue.Options.PoisonImbue
 */
export enum Rogue_Options_PoisonImbue {
    /**
     * @generated from protobuf enum value: NoPoison = 0;
     */
    NoPoison = 0,
    /**
     * @generated from protobuf enum value: InstantPoison = 1;
     */
    InstantPoison = 1,
    /**
     * @generated from protobuf enum value: DeadlyPoison = 2;
     */
    DeadlyPoison = 2,
    /**
     * @generated from protobuf enum value: WoundPoison = 3;
     */
    WoundPoison = 3
}
/**
 * @generated from protobuf enum proto.RogueMajorGlyph
 */
export enum RogueMajorGlyph {
    /**
     * @generated from protobuf enum value: RogueMajorGlyphNone = 0;
     */
    RogueMajorGlyphNone = 0,
    /**
     * @generated from protobuf enum value: GlyphOfAdrenalineRush = 42954;
     */
    GlyphOfAdrenalineRush = 42954,
    /**
     * @generated from protobuf enum value: GlyphOfAmbush = 42955;
     */
    GlyphOfAmbush = 42955,
    /**
     * @generated from protobuf enum value: GlyphOfBackstab = 42956;
     */
    GlyphOfBackstab = 42956,
    /**
     * @generated from protobuf enum value: GlyphOfBladeFlurry = 42957;
     */
    GlyphOfBladeFlurry = 42957,
    /**
     * @generated from protobuf enum value: GlyphOfCloakOfShadows = 45769;
     */
    GlyphOfCloakOfShadows = 45769,
    /**
     * @generated from protobuf enum value: GlyphOfCripplingPoison = 42958;
     */
    GlyphOfCripplingPoison = 42958,
    /**
     * @generated from protobuf enum value: GlyphOfDeadlyThrow = 42959;
     */
    GlyphOfDeadlyThrow = 42959,
    /**
     * @generated from protobuf enum value: GlyphOfEvasion = 42960;
     */
    GlyphOfEvasion = 42960,
    /**
     * @generated from protobuf enum value: GlyphOfEviscerate = 42961;
     */
    GlyphOfEviscerate = 42961,
    /**
     * @generated from protobuf enum value: GlyphOfExposeArmor = 42962;
     */
    GlyphOfExposeArmor = 42962,
    /**
     * @generated from protobuf enum value: GlyphOfFanOfKnives = 45766;
     */
    GlyphOfFanOfKnives = 45766,
    /**
     * @generated from protobuf enum value: GlyphOfFeint = 42963;
     */
    GlyphOfFeint = 42963,
    /**
     * @generated from protobuf enum value: GlyphOfGarrote = 42964;
     */
    GlyphOfGarrote = 42964,
    /**
     * @generated from protobuf enum value: GlyphOfGhostlyStrike = 42965;
     */
    GlyphOfGhostlyStrike = 42965,
    /**
     * @generated from protobuf enum value: GlyphOfGouge = 42966;
     */
    GlyphOfGouge = 42966,
    /**
     * @generated from protobuf enum value: GlyphOfHemorrhage = 42967;
     */
    GlyphOfHemorrhage = 42967,
    /**
     * @generated from protobuf enum value: GlyphOfHungerForBlood = 45761;
     */
    GlyphOfHungerForBlood = 45761,
    /**
     * @generated from protobuf enum value: GlyphOfKillingSpree = 45762;
     */
    GlyphOfKillingSpree = 45762,
    /**
     * @generated from protobuf enum value: GlyphOfMutilate = 45768;
     */
    GlyphOfMutilate = 45768,
    /**
     * @generated from protobuf enum value: GlyphOfPreparation = 42968;
     */
    GlyphOfPreparation = 42968,
    /**
     * @generated from protobuf enum value: GlyphOfRupture = 42969;
     */
    GlyphOfRupture = 42969,
    /**
     * @generated from protobuf enum value: GlyphOfSap = 42970;
     */
    GlyphOfSap = 42970,
    /**
     * @generated from protobuf enum value: GlyphOfShadowDance = 45764;
     */
    GlyphOfShadowDance = 45764,
    /**
     * @generated from protobuf enum value: GlyphOfSinisterStrike = 42972;
     */
    GlyphOfSinisterStrike = 42972,
    /**
     * @generated from protobuf enum value: GlyphOfSliceAndDice = 42973;
     */
    GlyphOfSliceAndDice = 42973,
    /**
     * @generated from protobuf enum value: GlyphOfSprint = 42974;
     */
    GlyphOfSprint = 42974,
    /**
     * @generated from protobuf enum value: GlyphOfTricksOfTheTrade = 45767;
     */
    GlyphOfTricksOfTheTrade = 45767,
    /**
     * @generated from protobuf enum value: GlyphOfVigor = 42971;
     */
    GlyphOfVigor = 42971
}
/**
 * @generated from protobuf enum proto.RogueMinorGlyph
 */
export enum RogueMinorGlyph {
    /**
     * @generated from protobuf enum value: RogueMinorGlyphNone = 0;
     */
    RogueMinorGlyphNone = 0,
    /**
     * @generated from protobuf enum value: GlyphOfBlurredSpeed = 43379;
     */
    GlyphOfBlurredSpeed = 43379,
    /**
     * @generated from protobuf enum value: GlyphOfDistract = 43376;
     */
    GlyphOfDistract = 43376,
    /**
     * @generated from protobuf enum value: GlyphOfPickLock = 43377;
     */
    GlyphOfPickLock = 43377,
    /**
     * @generated from protobuf enum value: GlyphOfPickPocket = 43343;
     */
    GlyphOfPickPocket = 43343,
    /**
     * @generated from protobuf enum value: GlyphOfSafeFall = 43378;
     */
    GlyphOfSafeFall = 43378,
    /**
     * @generated from protobuf enum value: GlyphOfVanish = 43380;
     */
    GlyphOfVanish = 43380
}
// @generated message type with reflection information, may provide speed optimized methods
class RogueTalents$Type extends MessageType<RogueTalents> {
    constructor() {
        super("proto.RogueTalents", [
            { no: 1, name: "improved_eviscerate", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "remorseless_attacks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "malice", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "ruthlessness", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "blood_spatter", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "puncturing_wounds", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "vigor", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "improved_expose_armor", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "lethality", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "vile_poisons", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "improved_poisons", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "fleet_footed", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "cold_blood", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "improved_kidney_shot", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "quick_recovery", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "seal_fate", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "murder", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "deadly_brew", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "overkill", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "deadened_nerves", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "focused_attacks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 22, name: "find_weakness", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 23, name: "master_poisoner", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 24, name: "mutilate", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 25, name: "turn_the_tables", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 26, name: "cut_to_the_chase", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 27, name: "hunger_for_blood", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 28, name: "improved_gouge", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 29, name: "improved_sinister_strike", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 30, name: "dual_wield_specialization", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 31, name: "improved_slice_and_dice", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 32, name: "deflection", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 33, name: "precision", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 34, name: "endurance", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 35, name: "riposte", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 36, name: "close_quarters_combat", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 37, name: "improved_kick", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 38, name: "improved_sprint", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 39, name: "lightning_reflexes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 40, name: "aggression", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 41, name: "mace_specialization", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 42, name: "blade_flurry", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 43, name: "hack_and_slash", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 44, name: "weapon_expertise", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 45, name: "blade_twisting", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 46, name: "vitality", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 47, name: "adrenaline_rush", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 48, name: "nerves_of_steel", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 49, name: "throwing_specialization", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 50, name: "combat_potency", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 51, name: "unfair_advantage", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 52, name: "surprise_attacks", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 53, name: "savage_combat", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 54, name: "prey_on_the_weak", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 55, name: "killing_spree", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 56, name: "relentless_strikes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 57, name: "master_of_deception", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 58, name: "opportunity", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 59, name: "sleight_of_hand", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 60, name: "dirty_tricks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 61, name: "camouflage", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 62, name: "elusiveness", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 63, name: "ghostly_strike", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 64, name: "serrated_blades", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 65, name: "setup", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 66, name: "initiative", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 67, name: "improved_ambush", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 68, name: "heightened_senses", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 69, name: "preparation", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 70, name: "dirty_deeds", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 71, name: "hemorrhage", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 72, name: "master_of_subtlety", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 73, name: "deadliness", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 74, name: "enveloping_shadows", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 75, name: "premeditation", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 76, name: "cheat_death", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 77, name: "sinister_calling", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 78, name: "waylay", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 79, name: "honor_among_thieves", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 80, name: "shadowstep", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 81, name: "filthy_tricks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 82, name: "slaughter_from_the_shadows", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 83, name: "shadow_dance", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RogueTalents>): RogueTalents {
        const message = { improvedEviscerate: 0, remorselessAttacks: 0, malice: 0, ruthlessness: 0, bloodSpatter: 0, puncturingWounds: 0, vigor: false, improvedExposeArmor: 0, lethality: 0, vilePoisons: 0, improvedPoisons: 0, fleetFooted: 0, coldBlood: false, improvedKidneyShot: 0, quickRecovery: 0, sealFate: 0, murder: 0, deadlyBrew: 0, overkill: false, deadenedNerves: 0, focusedAttacks: 0, findWeakness: 0, masterPoisoner: 0, mutilate: false, turnTheTables: 0, cutToTheChase: 0, hungerForBlood: false, improvedGouge: 0, improvedSinisterStrike: 0, dualWieldSpecialization: 0, improvedSliceAndDice: 0, deflection: 0, precision: 0, endurance: 0, riposte: false, closeQuartersCombat: 0, improvedKick: 0, improvedSprint: 0, lightningReflexes: 0, aggression: 0, maceSpecialization: 0, bladeFlurry: false, hackAndSlash: 0, weaponExpertise: 0, bladeTwisting: 0, vitality: 0, adrenalineRush: false, nervesOfSteel: 0, throwingSpecialization: 0, combatPotency: 0, unfairAdvantage: 0, surpriseAttacks: false, savageCombat: 0, preyOnTheWeak: 0, killingSpree: false, relentlessStrikes: 0, masterOfDeception: 0, opportunity: 0, sleightOfHand: 0, dirtyTricks: 0, camouflage: 0, elusiveness: 0, ghostlyStrike: false, serratedBlades: 0, setup: 0, initiative: 0, improvedAmbush: 0, heightenedSenses: 0, preparation: false, dirtyDeeds: 0, hemorrhage: false, masterOfSubtlety: 0, deadliness: 0, envelopingShadows: 0, premeditation: false, cheatDeath: 0, sinisterCalling: 0, waylay: 0, honorAmongThieves: 0, shadowstep: false, filthyTricks: 0, slaughterFromTheShadows: 0, shadowDance: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RogueTalents>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RogueTalents): RogueTalents {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 improved_eviscerate */ 1:
                    message.improvedEviscerate = reader.int32();
                    break;
                case /* int32 remorseless_attacks */ 2:
                    message.remorselessAttacks = reader.int32();
                    break;
                case /* int32 malice */ 3:
                    message.malice = reader.int32();
                    break;
                case /* int32 ruthlessness */ 4:
                    message.ruthlessness = reader.int32();
                    break;
                case /* int32 blood_spatter */ 5:
                    message.bloodSpatter = reader.int32();
                    break;
                case /* int32 puncturing_wounds */ 6:
                    message.puncturingWounds = reader.int32();
                    break;
                case /* bool vigor */ 7:
                    message.vigor = reader.bool();
                    break;
                case /* int32 improved_expose_armor */ 8:
                    message.improvedExposeArmor = reader.int32();
                    break;
                case /* int32 lethality */ 9:
                    message.lethality = reader.int32();
                    break;
                case /* int32 vile_poisons */ 10:
                    message.vilePoisons = reader.int32();
                    break;
                case /* int32 improved_poisons */ 11:
                    message.improvedPoisons = reader.int32();
                    break;
                case /* int32 fleet_footed */ 12:
                    message.fleetFooted = reader.int32();
                    break;
                case /* bool cold_blood */ 13:
                    message.coldBlood = reader.bool();
                    break;
                case /* int32 improved_kidney_shot */ 14:
                    message.improvedKidneyShot = reader.int32();
                    break;
                case /* int32 quick_recovery */ 15:
                    message.quickRecovery = reader.int32();
                    break;
                case /* int32 seal_fate */ 16:
                    message.sealFate = reader.int32();
                    break;
                case /* int32 murder */ 17:
                    message.murder = reader.int32();
                    break;
                case /* int32 deadly_brew */ 18:
                    message.deadlyBrew = reader.int32();
                    break;
                case /* bool overkill */ 19:
                    message.overkill = reader.bool();
                    break;
                case /* int32 deadened_nerves */ 20:
                    message.deadenedNerves = reader.int32();
                    break;
                case /* int32 focused_attacks */ 21:
                    message.focusedAttacks = reader.int32();
                    break;
                case /* int32 find_weakness */ 22:
                    message.findWeakness = reader.int32();
                    break;
                case /* int32 master_poisoner */ 23:
                    message.masterPoisoner = reader.int32();
                    break;
                case /* bool mutilate */ 24:
                    message.mutilate = reader.bool();
                    break;
                case /* int32 turn_the_tables */ 25:
                    message.turnTheTables = reader.int32();
                    break;
                case /* int32 cut_to_the_chase */ 26:
                    message.cutToTheChase = reader.int32();
                    break;
                case /* bool hunger_for_blood */ 27:
                    message.hungerForBlood = reader.bool();
                    break;
                case /* int32 improved_gouge */ 28:
                    message.improvedGouge = reader.int32();
                    break;
                case /* int32 improved_sinister_strike */ 29:
                    message.improvedSinisterStrike = reader.int32();
                    break;
                case /* int32 dual_wield_specialization */ 30:
                    message.dualWieldSpecialization = reader.int32();
                    break;
                case /* int32 improved_slice_and_dice */ 31:
                    message.improvedSliceAndDice = reader.int32();
                    break;
                case /* int32 deflection */ 32:
                    message.deflection = reader.int32();
                    break;
                case /* int32 precision */ 33:
                    message.precision = reader.int32();
                    break;
                case /* int32 endurance */ 34:
                    message.endurance = reader.int32();
                    break;
                case /* bool riposte */ 35:
                    message.riposte = reader.bool();
                    break;
                case /* int32 close_quarters_combat */ 36:
                    message.closeQuartersCombat = reader.int32();
                    break;
                case /* int32 improved_kick */ 37:
                    message.improvedKick = reader.int32();
                    break;
                case /* int32 improved_sprint */ 38:
                    message.improvedSprint = reader.int32();
                    break;
                case /* int32 lightning_reflexes */ 39:
                    message.lightningReflexes = reader.int32();
                    break;
                case /* int32 aggression */ 40:
                    message.aggression = reader.int32();
                    break;
                case /* int32 mace_specialization */ 41:
                    message.maceSpecialization = reader.int32();
                    break;
                case /* bool blade_flurry */ 42:
                    message.bladeFlurry = reader.bool();
                    break;
                case /* int32 hack_and_slash */ 43:
                    message.hackAndSlash = reader.int32();
                    break;
                case /* int32 weapon_expertise */ 44:
                    message.weaponExpertise = reader.int32();
                    break;
                case /* int32 blade_twisting */ 45:
                    message.bladeTwisting = reader.int32();
                    break;
                case /* int32 vitality */ 46:
                    message.vitality = reader.int32();
                    break;
                case /* bool adrenaline_rush */ 47:
                    message.adrenalineRush = reader.bool();
                    break;
                case /* int32 nerves_of_steel */ 48:
                    message.nervesOfSteel = reader.int32();
                    break;
                case /* int32 throwing_specialization */ 49:
                    message.throwingSpecialization = reader.int32();
                    break;
                case /* int32 combat_potency */ 50:
                    message.combatPotency = reader.int32();
                    break;
                case /* int32 unfair_advantage */ 51:
                    message.unfairAdvantage = reader.int32();
                    break;
                case /* bool surprise_attacks */ 52:
                    message.surpriseAttacks = reader.bool();
                    break;
                case /* int32 savage_combat */ 53:
                    message.savageCombat = reader.int32();
                    break;
                case /* int32 prey_on_the_weak */ 54:
                    message.preyOnTheWeak = reader.int32();
                    break;
                case /* bool killing_spree */ 55:
                    message.killingSpree = reader.bool();
                    break;
                case /* int32 relentless_strikes */ 56:
                    message.relentlessStrikes = reader.int32();
                    break;
                case /* int32 master_of_deception */ 57:
                    message.masterOfDeception = reader.int32();
                    break;
                case /* int32 opportunity */ 58:
                    message.opportunity = reader.int32();
                    break;
                case /* int32 sleight_of_hand */ 59:
                    message.sleightOfHand = reader.int32();
                    break;
                case /* int32 dirty_tricks */ 60:
                    message.dirtyTricks = reader.int32();
                    break;
                case /* int32 camouflage */ 61:
                    message.camouflage = reader.int32();
                    break;
                case /* int32 elusiveness */ 62:
                    message.elusiveness = reader.int32();
                    break;
                case /* bool ghostly_strike */ 63:
                    message.ghostlyStrike = reader.bool();
                    break;
                case /* int32 serrated_blades */ 64:
                    message.serratedBlades = reader.int32();
                    break;
                case /* int32 setup */ 65:
                    message.setup = reader.int32();
                    break;
                case /* int32 initiative */ 66:
                    message.initiative = reader.int32();
                    break;
                case /* int32 improved_ambush */ 67:
                    message.improvedAmbush = reader.int32();
                    break;
                case /* int32 heightened_senses */ 68:
                    message.heightenedSenses = reader.int32();
                    break;
                case /* bool preparation */ 69:
                    message.preparation = reader.bool();
                    break;
                case /* int32 dirty_deeds */ 70:
                    message.dirtyDeeds = reader.int32();
                    break;
                case /* bool hemorrhage */ 71:
                    message.hemorrhage = reader.bool();
                    break;
                case /* int32 master_of_subtlety */ 72:
                    message.masterOfSubtlety = reader.int32();
                    break;
                case /* int32 deadliness */ 73:
                    message.deadliness = reader.int32();
                    break;
                case /* int32 enveloping_shadows */ 74:
                    message.envelopingShadows = reader.int32();
                    break;
                case /* bool premeditation */ 75:
                    message.premeditation = reader.bool();
                    break;
                case /* int32 cheat_death */ 76:
                    message.cheatDeath = reader.int32();
                    break;
                case /* int32 sinister_calling */ 77:
                    message.sinisterCalling = reader.int32();
                    break;
                case /* int32 waylay */ 78:
                    message.waylay = reader.int32();
                    break;
                case /* int32 honor_among_thieves */ 79:
                    message.honorAmongThieves = reader.int32();
                    break;
                case /* bool shadowstep */ 80:
                    message.shadowstep = reader.bool();
                    break;
                case /* int32 filthy_tricks */ 81:
                    message.filthyTricks = reader.int32();
                    break;
                case /* int32 slaughter_from_the_shadows */ 82:
                    message.slaughterFromTheShadows = reader.int32();
                    break;
                case /* bool shadow_dance */ 83:
                    message.shadowDance = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RogueTalents, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 improved_eviscerate = 1; */
        if (message.improvedEviscerate !== 0)
            writer.tag(1, WireType.Varint).int32(message.improvedEviscerate);
        /* int32 remorseless_attacks = 2; */
        if (message.remorselessAttacks !== 0)
            writer.tag(2, WireType.Varint).int32(message.remorselessAttacks);
        /* int32 malice = 3; */
        if (message.malice !== 0)
            writer.tag(3, WireType.Varint).int32(message.malice);
        /* int32 ruthlessness = 4; */
        if (message.ruthlessness !== 0)
            writer.tag(4, WireType.Varint).int32(message.ruthlessness);
        /* int32 blood_spatter = 5; */
        if (message.bloodSpatter !== 0)
            writer.tag(5, WireType.Varint).int32(message.bloodSpatter);
        /* int32 puncturing_wounds = 6; */
        if (message.puncturingWounds !== 0)
            writer.tag(6, WireType.Varint).int32(message.puncturingWounds);
        /* bool vigor = 7; */
        if (message.vigor !== false)
            writer.tag(7, WireType.Varint).bool(message.vigor);
        /* int32 improved_expose_armor = 8; */
        if (message.improvedExposeArmor !== 0)
            writer.tag(8, WireType.Varint).int32(message.improvedExposeArmor);
        /* int32 lethality = 9; */
        if (message.lethality !== 0)
            writer.tag(9, WireType.Varint).int32(message.lethality);
        /* int32 vile_poisons = 10; */
        if (message.vilePoisons !== 0)
            writer.tag(10, WireType.Varint).int32(message.vilePoisons);
        /* int32 improved_poisons = 11; */
        if (message.improvedPoisons !== 0)
            writer.tag(11, WireType.Varint).int32(message.improvedPoisons);
        /* int32 fleet_footed = 12; */
        if (message.fleetFooted !== 0)
            writer.tag(12, WireType.Varint).int32(message.fleetFooted);
        /* bool cold_blood = 13; */
        if (message.coldBlood !== false)
            writer.tag(13, WireType.Varint).bool(message.coldBlood);
        /* int32 improved_kidney_shot = 14; */
        if (message.improvedKidneyShot !== 0)
            writer.tag(14, WireType.Varint).int32(message.improvedKidneyShot);
        /* int32 quick_recovery = 15; */
        if (message.quickRecovery !== 0)
            writer.tag(15, WireType.Varint).int32(message.quickRecovery);
        /* int32 seal_fate = 16; */
        if (message.sealFate !== 0)
            writer.tag(16, WireType.Varint).int32(message.sealFate);
        /* int32 murder = 17; */
        if (message.murder !== 0)
            writer.tag(17, WireType.Varint).int32(message.murder);
        /* int32 deadly_brew = 18; */
        if (message.deadlyBrew !== 0)
            writer.tag(18, WireType.Varint).int32(message.deadlyBrew);
        /* bool overkill = 19; */
        if (message.overkill !== false)
            writer.tag(19, WireType.Varint).bool(message.overkill);
        /* int32 deadened_nerves = 20; */
        if (message.deadenedNerves !== 0)
            writer.tag(20, WireType.Varint).int32(message.deadenedNerves);
        /* int32 focused_attacks = 21; */
        if (message.focusedAttacks !== 0)
            writer.tag(21, WireType.Varint).int32(message.focusedAttacks);
        /* int32 find_weakness = 22; */
        if (message.findWeakness !== 0)
            writer.tag(22, WireType.Varint).int32(message.findWeakness);
        /* int32 master_poisoner = 23; */
        if (message.masterPoisoner !== 0)
            writer.tag(23, WireType.Varint).int32(message.masterPoisoner);
        /* bool mutilate = 24; */
        if (message.mutilate !== false)
            writer.tag(24, WireType.Varint).bool(message.mutilate);
        /* int32 turn_the_tables = 25; */
        if (message.turnTheTables !== 0)
            writer.tag(25, WireType.Varint).int32(message.turnTheTables);
        /* int32 cut_to_the_chase = 26; */
        if (message.cutToTheChase !== 0)
            writer.tag(26, WireType.Varint).int32(message.cutToTheChase);
        /* bool hunger_for_blood = 27; */
        if (message.hungerForBlood !== false)
            writer.tag(27, WireType.Varint).bool(message.hungerForBlood);
        /* int32 improved_gouge = 28; */
        if (message.improvedGouge !== 0)
            writer.tag(28, WireType.Varint).int32(message.improvedGouge);
        /* int32 improved_sinister_strike = 29; */
        if (message.improvedSinisterStrike !== 0)
            writer.tag(29, WireType.Varint).int32(message.improvedSinisterStrike);
        /* int32 dual_wield_specialization = 30; */
        if (message.dualWieldSpecialization !== 0)
            writer.tag(30, WireType.Varint).int32(message.dualWieldSpecialization);
        /* int32 improved_slice_and_dice = 31; */
        if (message.improvedSliceAndDice !== 0)
            writer.tag(31, WireType.Varint).int32(message.improvedSliceAndDice);
        /* int32 deflection = 32; */
        if (message.deflection !== 0)
            writer.tag(32, WireType.Varint).int32(message.deflection);
        /* int32 precision = 33; */
        if (message.precision !== 0)
            writer.tag(33, WireType.Varint).int32(message.precision);
        /* int32 endurance = 34; */
        if (message.endurance !== 0)
            writer.tag(34, WireType.Varint).int32(message.endurance);
        /* bool riposte = 35; */
        if (message.riposte !== false)
            writer.tag(35, WireType.Varint).bool(message.riposte);
        /* int32 close_quarters_combat = 36; */
        if (message.closeQuartersCombat !== 0)
            writer.tag(36, WireType.Varint).int32(message.closeQuartersCombat);
        /* int32 improved_kick = 37; */
        if (message.improvedKick !== 0)
            writer.tag(37, WireType.Varint).int32(message.improvedKick);
        /* int32 improved_sprint = 38; */
        if (message.improvedSprint !== 0)
            writer.tag(38, WireType.Varint).int32(message.improvedSprint);
        /* int32 lightning_reflexes = 39; */
        if (message.lightningReflexes !== 0)
            writer.tag(39, WireType.Varint).int32(message.lightningReflexes);
        /* int32 aggression = 40; */
        if (message.aggression !== 0)
            writer.tag(40, WireType.Varint).int32(message.aggression);
        /* int32 mace_specialization = 41; */
        if (message.maceSpecialization !== 0)
            writer.tag(41, WireType.Varint).int32(message.maceSpecialization);
        /* bool blade_flurry = 42; */
        if (message.bladeFlurry !== false)
            writer.tag(42, WireType.Varint).bool(message.bladeFlurry);
        /* int32 hack_and_slash = 43; */
        if (message.hackAndSlash !== 0)
            writer.tag(43, WireType.Varint).int32(message.hackAndSlash);
        /* int32 weapon_expertise = 44; */
        if (message.weaponExpertise !== 0)
            writer.tag(44, WireType.Varint).int32(message.weaponExpertise);
        /* int32 blade_twisting = 45; */
        if (message.bladeTwisting !== 0)
            writer.tag(45, WireType.Varint).int32(message.bladeTwisting);
        /* int32 vitality = 46; */
        if (message.vitality !== 0)
            writer.tag(46, WireType.Varint).int32(message.vitality);
        /* bool adrenaline_rush = 47; */
        if (message.adrenalineRush !== false)
            writer.tag(47, WireType.Varint).bool(message.adrenalineRush);
        /* int32 nerves_of_steel = 48; */
        if (message.nervesOfSteel !== 0)
            writer.tag(48, WireType.Varint).int32(message.nervesOfSteel);
        /* int32 throwing_specialization = 49; */
        if (message.throwingSpecialization !== 0)
            writer.tag(49, WireType.Varint).int32(message.throwingSpecialization);
        /* int32 combat_potency = 50; */
        if (message.combatPotency !== 0)
            writer.tag(50, WireType.Varint).int32(message.combatPotency);
        /* int32 unfair_advantage = 51; */
        if (message.unfairAdvantage !== 0)
            writer.tag(51, WireType.Varint).int32(message.unfairAdvantage);
        /* bool surprise_attacks = 52; */
        if (message.surpriseAttacks !== false)
            writer.tag(52, WireType.Varint).bool(message.surpriseAttacks);
        /* int32 savage_combat = 53; */
        if (message.savageCombat !== 0)
            writer.tag(53, WireType.Varint).int32(message.savageCombat);
        /* int32 prey_on_the_weak = 54; */
        if (message.preyOnTheWeak !== 0)
            writer.tag(54, WireType.Varint).int32(message.preyOnTheWeak);
        /* bool killing_spree = 55; */
        if (message.killingSpree !== false)
            writer.tag(55, WireType.Varint).bool(message.killingSpree);
        /* int32 relentless_strikes = 56; */
        if (message.relentlessStrikes !== 0)
            writer.tag(56, WireType.Varint).int32(message.relentlessStrikes);
        /* int32 master_of_deception = 57; */
        if (message.masterOfDeception !== 0)
            writer.tag(57, WireType.Varint).int32(message.masterOfDeception);
        /* int32 opportunity = 58; */
        if (message.opportunity !== 0)
            writer.tag(58, WireType.Varint).int32(message.opportunity);
        /* int32 sleight_of_hand = 59; */
        if (message.sleightOfHand !== 0)
            writer.tag(59, WireType.Varint).int32(message.sleightOfHand);
        /* int32 dirty_tricks = 60; */
        if (message.dirtyTricks !== 0)
            writer.tag(60, WireType.Varint).int32(message.dirtyTricks);
        /* int32 camouflage = 61; */
        if (message.camouflage !== 0)
            writer.tag(61, WireType.Varint).int32(message.camouflage);
        /* int32 elusiveness = 62; */
        if (message.elusiveness !== 0)
            writer.tag(62, WireType.Varint).int32(message.elusiveness);
        /* bool ghostly_strike = 63; */
        if (message.ghostlyStrike !== false)
            writer.tag(63, WireType.Varint).bool(message.ghostlyStrike);
        /* int32 serrated_blades = 64; */
        if (message.serratedBlades !== 0)
            writer.tag(64, WireType.Varint).int32(message.serratedBlades);
        /* int32 setup = 65; */
        if (message.setup !== 0)
            writer.tag(65, WireType.Varint).int32(message.setup);
        /* int32 initiative = 66; */
        if (message.initiative !== 0)
            writer.tag(66, WireType.Varint).int32(message.initiative);
        /* int32 improved_ambush = 67; */
        if (message.improvedAmbush !== 0)
            writer.tag(67, WireType.Varint).int32(message.improvedAmbush);
        /* int32 heightened_senses = 68; */
        if (message.heightenedSenses !== 0)
            writer.tag(68, WireType.Varint).int32(message.heightenedSenses);
        /* bool preparation = 69; */
        if (message.preparation !== false)
            writer.tag(69, WireType.Varint).bool(message.preparation);
        /* int32 dirty_deeds = 70; */
        if (message.dirtyDeeds !== 0)
            writer.tag(70, WireType.Varint).int32(message.dirtyDeeds);
        /* bool hemorrhage = 71; */
        if (message.hemorrhage !== false)
            writer.tag(71, WireType.Varint).bool(message.hemorrhage);
        /* int32 master_of_subtlety = 72; */
        if (message.masterOfSubtlety !== 0)
            writer.tag(72, WireType.Varint).int32(message.masterOfSubtlety);
        /* int32 deadliness = 73; */
        if (message.deadliness !== 0)
            writer.tag(73, WireType.Varint).int32(message.deadliness);
        /* int32 enveloping_shadows = 74; */
        if (message.envelopingShadows !== 0)
            writer.tag(74, WireType.Varint).int32(message.envelopingShadows);
        /* bool premeditation = 75; */
        if (message.premeditation !== false)
            writer.tag(75, WireType.Varint).bool(message.premeditation);
        /* int32 cheat_death = 76; */
        if (message.cheatDeath !== 0)
            writer.tag(76, WireType.Varint).int32(message.cheatDeath);
        /* int32 sinister_calling = 77; */
        if (message.sinisterCalling !== 0)
            writer.tag(77, WireType.Varint).int32(message.sinisterCalling);
        /* int32 waylay = 78; */
        if (message.waylay !== 0)
            writer.tag(78, WireType.Varint).int32(message.waylay);
        /* int32 honor_among_thieves = 79; */
        if (message.honorAmongThieves !== 0)
            writer.tag(79, WireType.Varint).int32(message.honorAmongThieves);
        /* bool shadowstep = 80; */
        if (message.shadowstep !== false)
            writer.tag(80, WireType.Varint).bool(message.shadowstep);
        /* int32 filthy_tricks = 81; */
        if (message.filthyTricks !== 0)
            writer.tag(81, WireType.Varint).int32(message.filthyTricks);
        /* int32 slaughter_from_the_shadows = 82; */
        if (message.slaughterFromTheShadows !== 0)
            writer.tag(82, WireType.Varint).int32(message.slaughterFromTheShadows);
        /* bool shadow_dance = 83; */
        if (message.shadowDance !== false)
            writer.tag(83, WireType.Varint).bool(message.shadowDance);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.RogueTalents
 */
export const RogueTalents = new RogueTalents$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Rogue$Type extends MessageType<Rogue> {
    constructor() {
        super("proto.Rogue", [
            { no: 1, name: "rotation", kind: "message", T: () => Rogue_Rotation },
            { no: 3, name: "options", kind: "message", T: () => Rogue_Options }
        ]);
    }
    create(value?: PartialMessage<Rogue>): Rogue {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Rogue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Rogue): Rogue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.Rogue.Rotation rotation */ 1:
                    message.rotation = Rogue_Rotation.internalBinaryRead(reader, reader.uint32(), options, message.rotation);
                    break;
                case /* proto.Rogue.Options options */ 3:
                    message.options = Rogue_Options.internalBinaryRead(reader, reader.uint32(), options, message.options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Rogue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.Rogue.Rotation rotation = 1; */
        if (message.rotation)
            Rogue_Rotation.internalBinaryWrite(message.rotation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.Rogue.Options options = 3; */
        if (message.options)
            Rogue_Options.internalBinaryWrite(message.options, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Rogue
 */
export const Rogue = new Rogue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Rogue_Rotation$Type extends MessageType<Rogue_Rotation> {
    constructor() {
        super("proto.Rogue.Rotation", [
            { no: 1, name: "expose_armor_frequency", kind: "enum", T: () => ["proto.Rogue.Rotation.Frequency", Rogue_Rotation_Frequency] },
            { no: 2, name: "minimum_combo_points_expose_armor", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "tricks_of_the_trade_frequency", kind: "enum", T: () => ["proto.Rogue.Rotation.Frequency", Rogue_Rotation_Frequency] },
            { no: 4, name: "combat_finisher_priority", kind: "enum", T: () => ["proto.Rogue.Rotation.CombatPriority", Rogue_Rotation_CombatPriority] },
            { no: 25, name: "combat_builder", kind: "enum", T: () => ["proto.Rogue.Rotation.CombatBuilder", Rogue_Rotation_CombatBuilder] },
            { no: 5, name: "assassination_finisher_priority", kind: "enum", T: () => ["proto.Rogue.Rotation.AssassinationPriority", Rogue_Rotation_AssassinationPriority] },
            { no: 26, name: "subtlety_builder", kind: "enum", T: () => ["proto.Rogue.Rotation.SubtletyBuilder", Rogue_Rotation_SubtletyBuilder] },
            { no: 6, name: "subtlety_finisher_priority", kind: "enum", T: () => ["proto.Rogue.Rotation.SubtletyPriority", Rogue_Rotation_SubtletyPriority] },
            { no: 7, name: "minimum_combo_points_primary_finisher", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "minimum_combo_points_secondary_finisher", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "MultiTargetSliceFrequency", kind: "enum", jsonName: "MultiTargetSliceFrequency", T: () => ["proto.Rogue.Rotation.Frequency", Rogue_Rotation_Frequency] },
            { no: 10, name: "minimum_combo_points_multi_target_slice", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "use_feint", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "open_with_garrote", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "open_with_premeditation", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "open_with_shadowstep", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "rupture_for_bleed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "hemo_with_dagger", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 24, name: "use_ghostly_strike", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Rogue_Rotation>): Rogue_Rotation {
        const message = { exposeArmorFrequency: 0, minimumComboPointsExposeArmor: 0, tricksOfTheTradeFrequency: 0, combatFinisherPriority: 0, combatBuilder: 0, assassinationFinisherPriority: 0, subtletyBuilder: 0, subtletyFinisherPriority: 0, minimumComboPointsPrimaryFinisher: 0, minimumComboPointsSecondaryFinisher: 0, multiTargetSliceFrequency: 0, minimumComboPointsMultiTargetSlice: 0, useFeint: false, openWithGarrote: false, openWithPremeditation: false, openWithShadowstep: false, ruptureForBleed: false, hemoWithDagger: false, useGhostlyStrike: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Rogue_Rotation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Rogue_Rotation): Rogue_Rotation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.Rogue.Rotation.Frequency expose_armor_frequency */ 1:
                    message.exposeArmorFrequency = reader.int32();
                    break;
                case /* int32 minimum_combo_points_expose_armor */ 2:
                    message.minimumComboPointsExposeArmor = reader.int32();
                    break;
                case /* proto.Rogue.Rotation.Frequency tricks_of_the_trade_frequency */ 3:
                    message.tricksOfTheTradeFrequency = reader.int32();
                    break;
                case /* proto.Rogue.Rotation.CombatPriority combat_finisher_priority */ 4:
                    message.combatFinisherPriority = reader.int32();
                    break;
                case /* proto.Rogue.Rotation.CombatBuilder combat_builder */ 25:
                    message.combatBuilder = reader.int32();
                    break;
                case /* proto.Rogue.Rotation.AssassinationPriority assassination_finisher_priority */ 5:
                    message.assassinationFinisherPriority = reader.int32();
                    break;
                case /* proto.Rogue.Rotation.SubtletyBuilder subtlety_builder */ 26:
                    message.subtletyBuilder = reader.int32();
                    break;
                case /* proto.Rogue.Rotation.SubtletyPriority subtlety_finisher_priority */ 6:
                    message.subtletyFinisherPriority = reader.int32();
                    break;
                case /* int32 minimum_combo_points_primary_finisher */ 7:
                    message.minimumComboPointsPrimaryFinisher = reader.int32();
                    break;
                case /* int32 minimum_combo_points_secondary_finisher */ 8:
                    message.minimumComboPointsSecondaryFinisher = reader.int32();
                    break;
                case /* proto.Rogue.Rotation.Frequency MultiTargetSliceFrequency = 9 [json_name = "MultiTargetSliceFrequency"];*/ 9:
                    message.multiTargetSliceFrequency = reader.int32();
                    break;
                case /* int32 minimum_combo_points_multi_target_slice */ 10:
                    message.minimumComboPointsMultiTargetSlice = reader.int32();
                    break;
                case /* bool use_feint */ 12:
                    message.useFeint = reader.bool();
                    break;
                case /* bool open_with_garrote */ 15:
                    message.openWithGarrote = reader.bool();
                    break;
                case /* bool open_with_premeditation */ 16:
                    message.openWithPremeditation = reader.bool();
                    break;
                case /* bool open_with_shadowstep */ 17:
                    message.openWithShadowstep = reader.bool();
                    break;
                case /* bool rupture_for_bleed */ 18:
                    message.ruptureForBleed = reader.bool();
                    break;
                case /* bool hemo_with_dagger */ 20:
                    message.hemoWithDagger = reader.bool();
                    break;
                case /* bool use_ghostly_strike */ 24:
                    message.useGhostlyStrike = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Rogue_Rotation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.Rogue.Rotation.Frequency expose_armor_frequency = 1; */
        if (message.exposeArmorFrequency !== 0)
            writer.tag(1, WireType.Varint).int32(message.exposeArmorFrequency);
        /* int32 minimum_combo_points_expose_armor = 2; */
        if (message.minimumComboPointsExposeArmor !== 0)
            writer.tag(2, WireType.Varint).int32(message.minimumComboPointsExposeArmor);
        /* proto.Rogue.Rotation.Frequency tricks_of_the_trade_frequency = 3; */
        if (message.tricksOfTheTradeFrequency !== 0)
            writer.tag(3, WireType.Varint).int32(message.tricksOfTheTradeFrequency);
        /* proto.Rogue.Rotation.CombatPriority combat_finisher_priority = 4; */
        if (message.combatFinisherPriority !== 0)
            writer.tag(4, WireType.Varint).int32(message.combatFinisherPriority);
        /* proto.Rogue.Rotation.CombatBuilder combat_builder = 25; */
        if (message.combatBuilder !== 0)
            writer.tag(25, WireType.Varint).int32(message.combatBuilder);
        /* proto.Rogue.Rotation.AssassinationPriority assassination_finisher_priority = 5; */
        if (message.assassinationFinisherPriority !== 0)
            writer.tag(5, WireType.Varint).int32(message.assassinationFinisherPriority);
        /* proto.Rogue.Rotation.SubtletyBuilder subtlety_builder = 26; */
        if (message.subtletyBuilder !== 0)
            writer.tag(26, WireType.Varint).int32(message.subtletyBuilder);
        /* proto.Rogue.Rotation.SubtletyPriority subtlety_finisher_priority = 6; */
        if (message.subtletyFinisherPriority !== 0)
            writer.tag(6, WireType.Varint).int32(message.subtletyFinisherPriority);
        /* int32 minimum_combo_points_primary_finisher = 7; */
        if (message.minimumComboPointsPrimaryFinisher !== 0)
            writer.tag(7, WireType.Varint).int32(message.minimumComboPointsPrimaryFinisher);
        /* int32 minimum_combo_points_secondary_finisher = 8; */
        if (message.minimumComboPointsSecondaryFinisher !== 0)
            writer.tag(8, WireType.Varint).int32(message.minimumComboPointsSecondaryFinisher);
        /* proto.Rogue.Rotation.Frequency MultiTargetSliceFrequency = 9 [json_name = "MultiTargetSliceFrequency"]; */
        if (message.multiTargetSliceFrequency !== 0)
            writer.tag(9, WireType.Varint).int32(message.multiTargetSliceFrequency);
        /* int32 minimum_combo_points_multi_target_slice = 10; */
        if (message.minimumComboPointsMultiTargetSlice !== 0)
            writer.tag(10, WireType.Varint).int32(message.minimumComboPointsMultiTargetSlice);
        /* bool use_feint = 12; */
        if (message.useFeint !== false)
            writer.tag(12, WireType.Varint).bool(message.useFeint);
        /* bool open_with_garrote = 15; */
        if (message.openWithGarrote !== false)
            writer.tag(15, WireType.Varint).bool(message.openWithGarrote);
        /* bool open_with_premeditation = 16; */
        if (message.openWithPremeditation !== false)
            writer.tag(16, WireType.Varint).bool(message.openWithPremeditation);
        /* bool open_with_shadowstep = 17; */
        if (message.openWithShadowstep !== false)
            writer.tag(17, WireType.Varint).bool(message.openWithShadowstep);
        /* bool rupture_for_bleed = 18; */
        if (message.ruptureForBleed !== false)
            writer.tag(18, WireType.Varint).bool(message.ruptureForBleed);
        /* bool hemo_with_dagger = 20; */
        if (message.hemoWithDagger !== false)
            writer.tag(20, WireType.Varint).bool(message.hemoWithDagger);
        /* bool use_ghostly_strike = 24; */
        if (message.useGhostlyStrike !== false)
            writer.tag(24, WireType.Varint).bool(message.useGhostlyStrike);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Rogue.Rotation
 */
export const Rogue_Rotation = new Rogue_Rotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Rogue_Options$Type extends MessageType<Rogue_Options> {
    constructor() {
        super("proto.Rogue.Options", [
            { no: 1, name: "tricks_of_the_trade_target", kind: "message", T: () => UnitReference },
            { no: 2, name: "mh_imbue", kind: "enum", T: () => ["proto.Rogue.Options.PoisonImbue", Rogue_Options_PoisonImbue] },
            { no: 3, name: "oh_imbue", kind: "enum", T: () => ["proto.Rogue.Options.PoisonImbue", Rogue_Options_PoisonImbue] },
            { no: 4, name: "starting_overkill_duration", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "apply_poisons_manually", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "honor_of_thieves_crit_rate", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "assume_bleed_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "vanish_break_time", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value?: PartialMessage<Rogue_Options>): Rogue_Options {
        const message = { mhImbue: 0, ohImbue: 0, startingOverkillDuration: 0, applyPoisonsManually: false, honorOfThievesCritRate: 0, assumeBleedActive: false, vanishBreakTime: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Rogue_Options>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Rogue_Options): Rogue_Options {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference tricks_of_the_trade_target */ 1:
                    message.tricksOfTheTradeTarget = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.tricksOfTheTradeTarget);
                    break;
                case /* proto.Rogue.Options.PoisonImbue mh_imbue */ 2:
                    message.mhImbue = reader.int32();
                    break;
                case /* proto.Rogue.Options.PoisonImbue oh_imbue */ 3:
                    message.ohImbue = reader.int32();
                    break;
                case /* int32 starting_overkill_duration */ 4:
                    message.startingOverkillDuration = reader.int32();
                    break;
                case /* bool apply_poisons_manually */ 5:
                    message.applyPoisonsManually = reader.bool();
                    break;
                case /* int32 honor_of_thieves_crit_rate */ 6:
                    message.honorOfThievesCritRate = reader.int32();
                    break;
                case /* bool assume_bleed_active */ 7:
                    message.assumeBleedActive = reader.bool();
                    break;
                case /* float vanish_break_time */ 8:
                    message.vanishBreakTime = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Rogue_Options, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference tricks_of_the_trade_target = 1; */
        if (message.tricksOfTheTradeTarget)
            UnitReference.internalBinaryWrite(message.tricksOfTheTradeTarget, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.Rogue.Options.PoisonImbue mh_imbue = 2; */
        if (message.mhImbue !== 0)
            writer.tag(2, WireType.Varint).int32(message.mhImbue);
        /* proto.Rogue.Options.PoisonImbue oh_imbue = 3; */
        if (message.ohImbue !== 0)
            writer.tag(3, WireType.Varint).int32(message.ohImbue);
        /* int32 starting_overkill_duration = 4; */
        if (message.startingOverkillDuration !== 0)
            writer.tag(4, WireType.Varint).int32(message.startingOverkillDuration);
        /* bool apply_poisons_manually = 5; */
        if (message.applyPoisonsManually !== false)
            writer.tag(5, WireType.Varint).bool(message.applyPoisonsManually);
        /* int32 honor_of_thieves_crit_rate = 6; */
        if (message.honorOfThievesCritRate !== 0)
            writer.tag(6, WireType.Varint).int32(message.honorOfThievesCritRate);
        /* bool assume_bleed_active = 7; */
        if (message.assumeBleedActive !== false)
            writer.tag(7, WireType.Varint).bool(message.assumeBleedActive);
        /* float vanish_break_time = 8; */
        if (message.vanishBreakTime !== 0)
            writer.tag(8, WireType.Bit32).float(message.vanishBreakTime);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.Rogue.Options
 */
export const Rogue_Options = new Rogue_Options$Type();
